import { render } from "./Timetable.vue?vue&type=template&id=44c892e8"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__